export default {"src":"/_next/static/media/molar_24.88d0629d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};